import React, { useEffect, useState } from 'react';
import Badge from '@mui/material/Badge';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FileFolderEditIcon from '../../../common/Icons/FileFolderEditIcon';
import { HomeIcon, TimeExpenseIcon } from '../../../common/Icons';
import colors from '../../../../scss/colors';
import { AccountCircleOutlined } from '@mui/icons-material';

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined
  });

  return (
    <Slide appear={false} direction="up" in={!trigger}>
      {children}
    </Slide>
  );
}

const buttonStyles = {
  '&.MuiButtonBase-root.MuiBottomNavigationAction-root': {
    minWidth: '24px'
  },
  '&.MuiButtonBase-root.MuiBottomNavigationAction-root.Mui-selected': {
    color: colors.NAVY_BLUE
  },
  '&.MuiButtonBase-root.MuiBottomNavigationAction-root > .PrivateSwipeArea-root': {
    display: 'none'
  }
};

const swiper = {
  width: '50px',
  height: '8px',
  borderRadius: '10px',
  background: colors.LIGHT_GREY
};

export default function FooterPanel() {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const accessTo = useSelector((state) => state.accessToParts);
  const pendingTandECounts = useSelector((state) => state.timesheet?.tandecounts);

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [loggedout, setLoggedout] = useState(false);

  const logoutIdentifier = () => {
    setLoggedout(true);
  };
  const openDrawer = () => {
    setOpen(!open);
  };
  useEffect(() => {
    setValue(window.location.pathname);
  }, []);

  return (
    <HideOnScroll>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '60px' }} elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
            navigate(newValue);
          }}
        >
          <BottomNavigationAction
            label={t('common.header.menu.home')}
            icon={<HomeIcon />}
            sx={buttonStyles}
            value="/dashboard"
          />
          {!accessTo.tAndEApprover && (
            <BottomNavigationAction
              label={t('dashboard.jobs.job')}
              icon={<WorkOutlineIcon />}
              sx={buttonStyles}
              value="/dashboard/jobs"
            />
          )}
          {accessTo.onboarding && (
            <BottomNavigationAction
              label={t('common.header.menu.onboarding')}
              icon={<FileFolderEditIcon />}
              sx={buttonStyles}
              value="/dashboard/tifo"
            />
          )}
          {(accessTo.tAndEContractor || accessTo.tAndEApprover) && (
            <BottomNavigationAction
              label={t('dashboard.timesheets.sidetabTimeShort')}
              icon={
                <Badge badgeContent={pendingTandECounts?.PendingTimesheetCount} color="error" max={9}>
                  <TimeExpenseIcon />
                </Badge>
              }
              sx={buttonStyles}
              value="/dashboard/timesheets"
            />
          )}
          {(accessTo.tAndEContractor || accessTo.tAndEApprover) && (
            <BottomNavigationAction
              label={t('dashboard.expenses.sidetabExpense')}
              icon={
                <Badge badgeContent={pendingTandECounts?.PendingClaimsCount} color="error" max={9}>
                  <PaidOutlinedIcon />
                </Badge>
              }
              sx={buttonStyles}
              value="/dashboard/expenses"
            />
          )}
          <BottomNavigationAction
            value="/my-profile"
            label={t('common.header.menu.profile')}
            icon={<AccountCircleOutlined />}
            sx={buttonStyles}
          />
        </BottomNavigation>
      </Paper>
    </HideOnScroll>
  );
}
